import React, { ReactChild, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as ArrowButtonDownGray } from '@/assets/images/common/arrowButtonDownGray.svg';
import theme from '@/styles/theme';

interface Props {
  subMenu: ReactChild;
  title: string;
}

const Menu = ({ subMenu, title }: Props) => {
  const [shouldShowMenu, setShouldShowMenu] = useState(false);

  const handleToggle = () => {
    setShouldShowMenu(!shouldShowMenu);
  };

  return (
    <MenuWrapper onMouseEnter={handleToggle} onMouseLeave={handleToggle}>
      <MenuTitleWrapper>
        <MenuTitle>{title}</MenuTitle>
        <ArrowButtonDownGray />
      </MenuTitleWrapper>
      <SubMenuWrapper shouldShowMenu={shouldShowMenu}>
        {subMenu && subMenu}
      </SubMenuWrapper>
    </MenuWrapper>
  );
};

export default Menu;

const MenuWrapper = styled.div`
  position: relative;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;

  &:hover {
    background-color: ${theme.DF_COLOR.GRAY50};

    & > div > div {
      color: black;
    }
  }
`;

const MenuTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const MenuTitle = styled.div`
  margin-right: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #979797;
`;

const SubMenuWrapper = styled.div<{ shouldShowMenu: boolean }>`
  display: ${({ shouldShowMenu }) => (shouldShowMenu ? 'block' : 'none')};
  left: -36px;
  top: 40px;
  position: absolute;
  width: 180px;
  border: 1px solid #dfe1e2;
  border-radius: 8px;

  div {
    border-radius: 0;
  }

  div:first-child {
    border-top-width: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  div:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;
